import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["leftImage", "rightImage"];
  static values = {
    rotateLeft: { type: Number, default: -4 },
    rotateRight: { type: Number, default: 4 },
  };

  connect() {
    // Check if mobile
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      this.setStaticRotation();
    } else {
      this.setupScrollAnimation();
    }
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  setStaticRotation() {
    // Simply set the rotation without animation
    if (this.hasLeftImageTarget) {
      this.leftImageTarget.style.transform = `rotate(${this.rotateLeftValue}deg)`;
    }
    if (this.hasRightImageTarget) {
      this.rightImageTarget.style.transform = `rotate(${this.rotateRightValue}deg)`;
    }
  }

  setupScrollAnimation() {
    window.addEventListener("scroll", this.handleScroll, {
      passive: true,
    });

    // Set up CSS animations
    this.setupKeyframes();
    if (this.hasLeftImageTarget) {
      this.setupRotationAnimation(this.leftImageTarget, "rotateLeft");
    }
    if (this.hasRightImageTarget) {
      this.setupRotationAnimation(this.rightImageTarget, "rotateRight");
    }

    // Initial calculation
    this.handleScroll();
  }

  setupKeyframes() {
    if (!document.querySelector("#rotate-keyframes")) {
      const style = document.createElement("style");
      style.id = "rotate-keyframes";
      style.textContent = `
        @keyframes rotateLeft {
          from { transform: rotate(0deg); }
          to { transform: rotate(${this.rotateLeftValue}deg); }
        }
        @keyframes rotateRight {
          from { transform: rotate(0deg); }
          to { transform: rotate(${this.rotateRightValue}deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }

  setupRotationAnimation(element, animationName) {
    // Add keyframe animation
    element.style.animation = `${animationName} 1s linear infinite`;
    element.style.animationPlayState = "paused";
    element.style.animationIterationCount = "1";
    element.style.animationFillMode = "both";
  }

  handleScroll = () => {
    const rect = this.element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = viewportHeight / 2;

    // Calculate how far the element is from the center
    const distanceFromCenter = elementCenter - viewportCenter;
    const maxDistance = viewportHeight / 2;

    // Calculate progress based on direction
    let progress;
    if (distanceFromCenter > 0) {
      // Element is below center - progress from 0 to 1
      progress = Math.max(0, Math.min(1, 1 - distanceFromCenter / maxDistance));
    } else {
      // Element is above center - stay at 1
      progress = 1;
    }

    // Update animation delay based on scroll position
    if (this.hasLeftImageTarget) {
      this.leftImageTarget.style.animationDelay = `${-progress}s`;
    }
    if (this.hasRightImageTarget) {
      this.rightImageTarget.style.animationDelay = `${-progress}s`;
    }
  };
}
